import {Component, Input, OnChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {GovernanceGroup} from '../../../model/milestones/GovernanceGroup';
import {MilestoneDefinitions} from '../../../services/milestones/MilestoneDefinitions';

@Component({
  selector: 'digires-governance-group-selector',
  templateUrl: './governance-group-selector.component.html',
  styleUrls: ['./governance-group-selector.component.scss']
})
export class GovernanceGroupSelectorComponent implements OnChanges {

  @Input() milestoneDefs: MilestoneDefinitions;
  @Input() formGroup: FormGroup;
  @Input() group: GovernanceGroup;
  @Input() readOnly: boolean = false;
  @Input() readOnlyReason: string;
  refMap: {[msDefId: string]: string} = {};
  labelMap: {[msDefId: string]: string} = {};
  tooltipMap: {[msDefId: string]: string} = {};

  ngOnChanges() {
    if (this.milestoneDefs && this.group) {
      this.labelMap = {};
      for (const defId of this.group.milestoneCommonIds) {
        const commonMsDef = this.milestoneDefs.commonMilestonesMap[defId];
        this.refMap[defId] = commonMsDef?.customRef ? commonMsDef.customRef : '';
        this.labelMap[defId] = commonMsDef?.name ? commonMsDef.name : defId;
        this.tooltipMap[defId] = commonMsDef?.summary;
      }
    }

    if(this.readOnly) {
      this.formGroup.disable();
    } else {
      this.formGroup.enable();
    }
  }

}
